{
  "enum": {
    "ExcMarketdataV1ChartPeriod": {
      "FIVE_YEARS": "Five Years",
      "ONE_DAY": "One Day",
      "ONE_MONTH": "One Month",
      "ONE_WEEK": "One Week",
      "ONE_YEAR": "One Year",
      "TEN_YEARS": "Ten Years",
      "THREE_MONTHS": "Three Months",
      "UNSPECIFIED": "Unspecified",
      "YEAR_TO_DATE": "Year to Date"
    },
    "ExcMarketdataV1FilingCategory": {
      "ANNUAL_REPORTS": "Annual Reports",
      "EIGHT_K_RELATED": "8-K Related",
      "INSIDER_TRANSACTIONS": "Insider Transactions",
      "PROXIES_AND_INFO_STATEMENTS": "Proxies and Info Statements",
      "QUARTERLY_REPORTS": "Quarterly Reports",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcMarketdataV1FinancialReportType": {
      "ANNUAL": "Annual",
      "QUARTERLY": "Quarterly",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "ExcMarketdataV1MarketDataServiceGetCompanyFilingsFilterableFields": {
      "category": "Category",
      "dateFiled": "Date Filed"
    }
  }
}